<script>
import map from 'lodash/map';
import Multiselect from 'vue-multiselect';
import ParamModel from '@models/Param';

export default {
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    state: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      roles: [],
      isLoading: false,
      selectedRoles: this.value,
      focused: false,
    };
  },
  mounted() {
    ParamModel.params({
      select_many: ['admin-roles'].join(','),
    })
      .first()
      .then((response) => {
        this.roles = map(response.roles, (item) => ({ name: item.name, id: item.id }));
      });
  },
  methods: {
    updateValue(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<template>
  <div class="multiselect-container kks-multiselect-container" :class="{ 'is-invalid': state, focused: focused }">
    <Multiselect
      placeholder="Pick some values"
      label="name"
      track-by="id"
      :value="value"
      :options="roles"
      :multiple="true"
      :close-on-select="false"
      :clear-on-select="true"
      :preserve-search="true"
      @input="updateValue"
      @open="focused = true"
      @close="focused = false"
    >
    </Multiselect>
  </div>
</template>
